<template>
    <div>
        <buttonlist @help="help" @print="confirmPrint"
                    ref="SetBtn"></buttonlist>

        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <!--<el-button type="primary" size="mini" @click="keyPasteButton()">粘贴</el-button>-->
                    <el-button type="primary" size="mini" @click="add()">{{$t('getapi[4412]')}}</el-button>
                    <el-button type="primary" size="mini" @click="deleteAll(0)">{{$t('getapi[4411]')}}</el-button>
                    <el-button type="primary" size="mini" @click="deleteAll(1)">{{$t('getapi[7108]')}}</el-button>
                    <!--<el-select v-model="printflag" :placeholder="$t('getapi[7111]')" style="margin-left: 8px">
                        <el-option :label="$t('getapi[12188]')" :value=1></el-option>
                        <el-option :label="$t('getapi[12758]')" :value=6></el-option>
                        <el-option :label="$t('getapi[12189]')" :value=2></el-option>
                        <el-option :label="$t('getapi[12190]')" :value=3></el-option>
                        <el-option :label="$t('getapi[12596]')+1" :value=4></el-option>
                        <el-option :label="$t('getapi[12596]')+2" :value=5></el-option>
                    </el-select>-->
                    <el-select filterable class-name="check" v-model="printflag">
                        <el-option v-for="item in printflagarr"
                                   :key="item.lcdtype" :label="item.Name" :value="item.lcdtype" size="mini"></el-option>
                    </el-select>
                    <el-select v-model="orderby" :placeholder="$t('getapi[2023]')" style="margin-left: 8px">
                        <el-option :label="$t('getapi[12822]')" :value=1></el-option>
                        <el-option :label="$t('getapi[12823]')" :value=2></el-option>
                        <el-option :label="$t('getapi[12824]')" :value=3></el-option>
                        <el-option :label="$t('getapi[13640]')" :value=4></el-option>
                    </el-select>
                </div>
            </div>
        </el-card>

        <el-table
                id="xpane-0"
                :data="datajson"
                ref="singleTable"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column prop="so_code" :label="$t('getapi[6784]')" width="150">
                <template scope="scope">
                    <el-input v-model="scope.row.so_code" type="text" @change="checkline(scope.row.so_code, scope)"></el-input>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="status" :label="$t('getapi[6998]')" width="150"></el-table-column>
        </el-table>

        <el-dialog v-dialogDrag :visible.sync="visPrintType" width="25%" :close-on-click-modal="false"  :title="$t('getapi[7111]')">
            <table>
                <tr>
                    <td><el-radio v-model="printflag" :label=1>{{$t('getapi[12188]')}}</el-radio></td>
                    <td><el-radio v-model="printflag" :label=2>{{$t('getapi[12189]')}}</el-radio></td>
                </tr>
                <tr>
                    <td><el-radio v-model="printflag" :label=3>{{$t('getapi[12190]')}}</el-radio></td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
        <el-button @click="visPrintType	=	false" size='mini'>{{ $t('getapi[2054]') }}</el-button>
        <el-button type="primary" size='mini' @click="confirmPrint">{{ $t('getapi[7114]') }}</el-button>
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: '2_soprint',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                fileList: [],
                itevisible: false,
                tabIndex: '0',
                ids: '',
                showloading: '',
                DbTbNames: '', //表名
                datajson: [],
                datajsonremark: [],
                datajsonliu: [],
                loading: false, // 主表加载状态
                drosele: 0,
                droseleliu: 0,
                total1: 0,
                btn: {
                    //添加
                    Add: true,
                    //移除
                    Remove: false,
                    //导入
                    Import: true
                },
                visPrintType: false,
                printflag: null,
                printflagarr:[],
                scrollTop:0,
                orderby:1,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            this.btnauthority();
        },
        watch: {
            datajson: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this
            this.$nextTick(() => {
                addEventListener('paste', this.keyPaste);//创建键盘粘贴监听事件
            });
            this.printflag = this.$http.getPageSize('LCDPrnt') == 100 ? 1:this.$http.getPageSize('LCDPrnt').toString()
            this.orderby = this.$http.getPageSize('LCDOrderBy') == 100 ? 1:this.$http.getPageSize('LCDOrderBy')
            let data = {
                "Code": "pro_so_master",
                "LangType": that.$processdata.getLang()
            }
            $.ajax({
                url: Common.Url + 'Basic/GetPrintTemplates?token=' + JSON.parse(sessionStorage.getItem('userData')).token,
                type: 'post',
                async: false,
                data: JSON.stringify(data),
                contentType: 'application/json',
                success: function (res) {
                    if (res.Success == 1) {
                        that.printflagarr = res.DataContent;
                        console.log(that.printflagarr)
                    } else {
                        //Message.error(res.Msg);
                    }
                },
                error: function (xhr, errorType, error) {
                }
            });
            this.authority();
            this.btnauthority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        beforeDestroy() {
            removeEventListener('paste', this.keyPaste);
        },
        methods: {
            keyPaste(e) {
                let that = this;
                if (this.$route.name == this.$options.name) {
                    if (e.clipboardData) {
                        var data = e.clipboardData.getData('Text');
                        if (!that.$limits.fnIsEmpty(data)) {
                            that.check(data);
                        }
                    }
                }
            },
            keyPasteButton() {
                /*//let sx= window.getSelection();
                //从session中读取
                let that = this;
                //并且清空
                let socodes = sessionStorage.getItem('socodes');
                if(!that.$limits.fnIsEmpty(socodes)){
                    that.check(socodes);
                }*/
                let that = this
                let data = window.clipboardData.getData('Text');
                if (!that.$limits.fnIsEmpty(data)) {
                    that.check(data);
                }
            },
            check(datap) {
                //校验
                let that = this;
                that.loading = true;
                let data = {
                    "MultyVer": 0,
                    "iTemplate": '',
                    "FilePath": datap,
                };
                let posturl = '/Pro/SO/SoPrintCheck';
                that.$http.urlpost(posturl, data, function (res) {
                    if (res.Success == 1) {
                        if (res.DataContent != null && res.DataContent.length > 0) {
                            for (let i = 0; i < res.DataContent.length; i++) {
                                that.datajson.push(res.DataContent[i]);
                            }
                        }
                    }
                    that.loading = false;
                });
            },
            checkline(datap,row){
                let that = this;
                that.loading = true;
                let index = row.$index
                console.log('index' + index)
                let data = {
                    "MultyVer": 0,
                    "iTemplate": '',
                    "FilePath": datap,
                };
                let posturl = '/Pro/SO/SoPrintCheck';
                that.$http.urlpost(posturl, data, function (res) {
                    if (res.Success == 1) {
                        if(res.DataContent.length == 1){
                            that.datajson[index] = res.DataContent[0]
                        }
                    }
                    that.loading = false;
                });
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4945]"),this.$t("getapi[25]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('print');

            },
            btnauthority() {
                let that = this;
                //工时
                that.btn.Manhour = false;
                //备注
                that.btn.Notes = false;

                if (that.$limits.authority('plv3', 38, 1) > 0) {
                    //工时
                    that.btn.Manhour = true;
                    //备注
                    that.btn.Notes = true;
                }

            },
            print() {
                let that = this;
                that.loading = true;
                that.$http.urlpost('/Print/LCDPrnt', that.datajson, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });

            },
            /*printnew(){
                let that = this
                if(that.datajson.length < 1){
                    that.$message.warning(that.$t('getapi[9036]'))
                    return
                }
                that.printflag = this.$http.getPageSize('LCDPrnt')
                that.visPrintType = true
            },*/
            confirmPrint(){
                let that = this;
                if(that.datajson.length < 1){
                    that.$message.warning(that.$t('getapi[9036]'))
                    return
                }
                that.loading = true;
                that.datajson = that.distinct(that.datajson)
                let pf = that.printflag
                for(let i=0;i<that.datajson.length;i++){
                    that.datajson[i].LCDType = that.printflag
                    that.datajson[i].order_by = that.orderby
                }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.$http.urlpost('/Print/LCDPrnt', that.datajson, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('print', true);
                    if (res.Success == 1) {
                        that.visPrintType=	false
                        that.$http.savePageSize('LCDPrnt',that.printflag)
                        that.$http.savePageSize('LCDOrderBy',that.orderby)
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    }                    
                    that.loading = false;
                });
            },
            distinct( arr){
                var newArr= [];
                var arrId = [];
                for(var item of arr){
                    if(arrId.indexOf(item['so_code']) == -1){
                        arrId.push(item['so_code']);
                        newArr.push(item);
                    }
                }
                return newArr
            },
            deleteAll(e) {
                let that = this;
                if (e == 0) {
                    for (let i = that.selectIDData.length - 1; i >= 0; i--) {
                        that.datajson.splice(that.selectIDData[i].index, 1);
                    }
                } else {
                    that.datajson = [];
                }
            },
            //删除行
            delline(e) {
                console.log(e);
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajson.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            dellines(e) {
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajsonremark.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },
            dellineliu(e) {
                let line = e.$rowIndex;
                if (line >= 0) {
                    this.datajsonliu.splice(line, 1);
                } else {
                    this.$message.error(this.$t('getapi[8710]'));//'移除失败'
                }
            },

            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = val;
            },


            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
            },
            add() {
                let that = this
                that.datajson = [...that.datajson, {
                    so_code: '',
                    status: ''
                }]
            }
        }
    };
</script>

<style lang="scss" scoped>
    span.label-fade-enter {
        font-size: medium;
        margin-right: 20px;
    }
</style>
<style>
    .el-message-box {
        width: 600px;
    }
</style>
